import { Directive, ElementRef, inject } from '@angular/core';
import { Tooltip } from 'primeng/tooltip';

/**
 * The label only needs a tooltip when the card has clipped it. Measuring on enter checks the one
 * label under the pointer, so a board of cards does not measure every label on each update.
 * PrimeNG waits showDelay before showing, and this listener is registered first, so the decision
 * is in place before that timer fires.
 */
@Directive({
  selector: '[clippedTooltip]',
  standalone: true,
  host: {
    '(mouseenter)': 'arm()',
  },
})
export class ClippedTooltipDirective {

  private readonly tooltip = inject(Tooltip);
  private readonly element = inject(ElementRef<HTMLElement>);

  arm(): void {

    const node = this.element.nativeElement;
    this.tooltip.setOption({ disabled: node.scrollWidth <= node.clientWidth });
  }
}
